const getCaseStudyVideos = () => {
  const videos = [
    {
      id: "kbt3hk7eyp",
      title:
        "Presentation Design for CEO Buy‑In: Turning a Complex Algorithm into a Clear Story",
      desc: `My client needed to clearly explain a complex algorithm to their
          CEO. Working from a detailed text file, I designed a concise
          visual that made the process easy to grasp, effectively
          highlighting how the algorithm saves the company valuable time.
          The CEO quickly understood the impact, helping the team secure
          buy-in for their solution.`,
    },
    // {
    //   id: "w8lqjd4iwq",
    //   title:
    //     "In‑House Web Application Presentation Design: Explaining the Tech Stack and Business Impact",
    //   desc: `For this internal project, I designed a presentation to introduce a new in‑house custom web application. The deck walked stakeholders through the problem the app solves, the chosen tech stack and architecture, and the measurable impact on workflow efficiency. I transformed technical details into clear visuals and narratives so both technical and non‑technical audiences could understand how the application works and why it matters to the business.`,
    // },
    {
      id: "l7c75cr5na",
      title:
        "PowerPoint Presentation Redesign: From Text Outline to Engaging End‑of‑Year Deck",
      desc: `For this end-of-year business unit presentation, my client
          provided a text-only PowerPoint outline. I transformed it into a
          visually engaging deck that helped the team share their
          achievements and insights with clarity. The completed presentation
          helped the team present with confidence and earned positive
          feedback from leadership.`,
    },
  ]

  return videos
}

export default getCaseStudyVideos
